import { StackSimple } from "@phosphor-icons/react";
import { SectionShell } from "../Primitives";
import { ELEVATION } from "@/data/designTokens";

export function ElevationSection() {
  return (
    <SectionShell
      id="elevation"
      eyebrow="Elevation"
      eyebrowIcon={StackSimple}
      title="Soft shadows, gentle lift"
      description="Shadows are diffuse and low-contrast — they suggest a soft lift rather than a hard drop. In dark mode they deepen with shadow rather than glow, keeping the calm, premium mood."
    >
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {ELEVATION.map((e) => (
          <div key={e.token} className="rounded-3xl bg-muted/40 p-6">
            <div className={`flex h-28 items-center justify-center rounded-2xl bg-card ${e.cls}`}>
              <span className="font-display text-lg font-extrabold">{e.token}</span>
            </div>
            <p className="mt-4 font-bold">{e.desc}</p>
            <code className="mt-1 block font-mono text-xs font-semibold text-muted-foreground">{e.value}</code>
          </div>
        ))}
      </div>
    </SectionShell>
  );
}

export default ElevationSection;
